/* istanbul ignore file - better tested visually */

import { ReactNode } from 'react';
import { ErrorMessage } from '../ErrorMessage';
import styles from './ErrorPage.module.scss';

type ErrorPageProps = {
  icon: ReactNode;
  title: ReactNode;
  message: ReactNode;
  actions?: ReactNode;
};

export function ErrorPage({ ...props }: Readonly<ErrorPageProps>) {
  return (
    <div className={styles.error}>
      <ErrorMessage {...props} />
    </div>
  );
}
